import './BottomBar.scss';

import React, { ReactNode } from 'react';

interface IProps {
  children?: ReactNode | ReactNode[];
}

export function BottomBar({ children }: IProps) {
  return (
    <>
      <div className="modBottomBarSpacer" />
      <footer className="modBottomBar">{children}</footer>
    </>
  );
}

export default BottomBar;
